import React, {Component} from 'react';
import MediaQuery from 'react-responsive';
import styled from 'styled-components';

import Screen from './Screen';
import Input from './Input';
import Content from './Content';
import Card from './Card';
import VirtualizedList from './VirtualizedList';

class ListScreen extends Component {
  static defaultProps = {
    items: [],
    primaryAction: null,
    toolbarActions: [],
    mobileActions: []
  };

  actions() {
    const {toolbarActions} = this.props;

    return toolbarActions.map(action => {
      if (action && action.type === Input) {
        return (
          <ResponsiveInputAction>
            {action}
          </ResponsiveInputAction>
        );
      }

      return action;
    });
  }

  renderResponsive = isSmallScreen => {
    const {title, activeLink, showTitle, tabs, search, onSearch, mobileActions, loading, error, empty, items, children} = this.props;
    let {primaryAction} = this.props;
    const placeholder = `Search ${title}...`;
    
    if (typeof primaryAction === 'function') {
      primaryAction = primaryAction({isSmallScreen});
    }

    return (
      <Screen
        title={title}
        activeLink={activeLink}
        showTitle={showTitle}
        actions={[primaryAction, ...(isSmallScreen && mobileActions ? mobileActions : []), ...this.actions()]}
        tabs={tabs}>
        {loading ? loading : error ? error : (
          <Content>
            <MobileSearchInput>
              <SearchInput placeholder={placeholder} value={search} onChange={onSearch} />
            </MobileSearchInput>
            <Card>
              <DesktopToolbar
                start={this.actions()}
                end={<SearchInput placeholder={placeholder} value={search} onChange={onSearch} />}
              />
              {items.length < 1 ? (
                <NoContent>{empty}</NoContent>
              ) : (
                <VirtualizedList window items={items}>
                  {children}
                </VirtualizedList>
              )}
            </Card>
          </Content>
        )}
      </Screen>
    );
  }

  render() {
    return <MediaQuery maxWidth="50rem" children={this.renderResponsive} />;
  }
}

function ResponsiveInputAction({children}) {
  return (
    <MediaQuery maxWidth="50rem">
      {isSmallScreen => (
        React.cloneElement(children, {
          labelPosition: isSmallScreen ? 'top' : 'start'
        })
      )}
    </MediaQuery>
  );
}

const DesktopToolbar = styled(Card.Toolbar)`
  @media (max-width: 50rem) {
    display: none;
  }
`;

const MobileSearchInput = styled.div`
  display: none;

  @media (max-width: 50rem) {
    display: block;
    margin-bottom: 1.25rem;
  }
`;

const SearchInput = styled(props => <Input type="text" {...props} />)`
  width: 22rem;

  @media (max-width: 50rem) {
    width: auto;
  }
`;

const NoContent = styled(Card.Content)`
  text-align: center;
`;

export default ListScreen;